module.exports = __webpack_public_path__ + "c_static/img/小程序搜索拼多多.7c3d5bd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/小程序搜索拼多多.jpg
// module id = Gn50
// module chunks = 33